import { connect } from 'react-redux';
import { selectFormInitialResourceFromTable } from 'redux/form/selectors';
import { IRootState } from 'redux/reducer';
import { fetchObatsTemplatesSagaAction } from 'redux/restResources/detail/obat/actions';
import {
  selectObatsTemplateAgeOptionsFunction,
  selectObatsTemplateUseOptions,
} from 'redux/restResources/detail/obat/selectors';
import { selectRouteResource } from 'redux/routing/selectors';
import { IRestResource } from 'types/RestResource';
import { rrc } from 'utils/strings/resourceClasses';

import { ObatForm as ObatFormComponent } from './ObatForm.component';

interface IOwnProps {
  getCreationSuccessLandingPageUrl: (routeProjectId: string, createdGeometry: IRestResource) => string;
}

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = typeof mapDispatchToProps;

export type IInjectedProps = IStateProps & IDispatchProps;

export type IProps = IOwnProps & IInjectedProps;

const mapStateToProps = (rootState: IRootState) => {
  const obatToEdit = selectFormInitialResourceFromTable(rrc.obat)(rootState);

  return {
    obatToEdit,
    routeProject: selectRouteResource(rrc.project)(rootState),
    templateUseOptions: selectObatsTemplateUseOptions(rootState),
    selectTemplateAgeOptions: selectObatsTemplateAgeOptionsFunction(rootState),
  };
};

const mapDispatchToProps = {
  fetchObatsTemplates: fetchObatsTemplatesSagaAction,
};

export const ObatForm = connect(mapStateToProps, mapDispatchToProps)(ObatFormComponent);
